const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-20">
    <div className="w-12 h-12 border-4 border-triangulo-red border-t-transparent rounded-full animate-spin"></div>
  </div>
);

export default LoadingSpinner;
